export default "__VITE_ASSET__Dh3twPnc__"